import React, { useMemo } from 'react';
import Card from 'react-bootstrap/Card';
import EditableParam from './EditableParam';

export type MonthlyProgress = { level: number | string; progressToNextLevel: number | string };

type Props<M> = {
  monthly: M;
  onChange: (monthly: M) => void;
};

export default function MonthlyEditor({ monthly, onChange }: Props<MonthlyProgress>) {
  // Snapshot of the values on mount, shown as the placeholder of each field
  const { level, progressToNextLevel } = useMemo(
    () => ({
      level: String(monthly.level),
      progressToNextLevel: String(monthly.progressToNextLevel),
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  // @ts-ignore
  const handleChangeMonthly = (key: string) => (event) => {
    const { value } = event.target;
    if (onChange) {
      onChange({ ...monthly, [key]: value });
    }
  };

  if (!monthly) return null;

  return (
    <Card>
      <Card.Body>
        <EditableParam
          key="level"
          title="level"
          value={monthly.level}
          onChange={handleChangeMonthly('level')}
          placeholder={level}
        />
        <EditableParam
          key="progressToNextLevel"
          title="progressToNextLevel"
          value={monthly.progressToNextLevel}
          onChange={handleChangeMonthly('progressToNextLevel')}
          placeholder={progressToNextLevel}
        />
      </Card.Body>
    </Card>
  );
}
